export const en = {
    "k_dc7f55f9": "Organizational structure",
    "k_5d911031": "Search user",
    "k_688d063": "Filtration",
    "k_b4b19a60": "Obtain user",
    "k_50e0cc3f": "User ID"
};
